import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

// Removes a Unit Upgrade track. Its name and description stay in localization, for Prune to offer.
export class RemoveUnitUpgradeTrackCommand extends CommandBase {
    uid: string;

    constructor(uid: string) {
        super();
        this.uid = uid;
    }

    execute(data: RemoteConstantsModel): boolean {
        const before = data.unitUpgrades?.length ?? 0;
        data.unitUpgrades = (data.unitUpgrades ?? []).filter(t => t.uid !== this.uid);
        return data.unitUpgrades.length !== before;
    }
}
